<script>
// import { ref, watch } from "vue";
// import useVuelidate from "@vuelidate/core";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import Swal from "sweetalert2";

import axios from 'axios';
// import DataTable from 'datatables.net-vue3';
export default {

    data() {
        return {

            title: "My Voucher History",
            
            isLoadingToDisplayData:true,
            staticURLDownload: process.env.VUE_APP_API_BASEURL,

            orderlist:[],
            newUrl: '',
        };
    },
    page: {
        title: "Order List",
        meta: [{ name: "Order List", content: appConfig.description }],
    },

  

    mounted() {
        this.staticURLDownload = this.staticURLDownload.replace('/api','');
		this.listImei();
		this.createTemplate();
	},

  methods: {

    listImei(){
        this.isLoadingToDisplayData=true;
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        this.UrlApi = +this.$route.params.statusId;

        axios.get(process.env.VUE_APP_API_BASEURL+'imei/list/tu/'+this.$route.params.OrderId)
        .then(response => {

            if (response) {
                
                this.orderlist = response.data;
                console.log(this.orderlist.url);
                this.newUrl = this.orderlist.url;
                this.isLoadingToDisplayData=false;
            } else {
                this.messageBag = ['No record.'];
                this.isLoadingToDisplayData=false;
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.isLoadingToDisplayData=false;
        });


    },

    createTemplate(){
        axios.get(process.env.VUE_APP_API_BASEURL+'voucher/gettemplate/'+this.$route.params.OrderId)
        .then(response => {
            console.log(response.data);
            this.listImei();
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.isLoadingToDisplayData=false;
        });
    },

    

    submitFile(){
        if(this.Images){
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);


            const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'imei/insert', formData, 
                { headers }
            ).then((res) => {
                    if(res.data.status=='successfully'){
                        
                        Swal.fire({
                            title:"Upload IMEI Success!", 
                            // html: "", 
                            icon:"success",
                        }).then(() => {
                            window.location = process.env.VUE_APP_BASE_URL+'/order/po/'+this.orderlist.device[0].order_id;
                        });
                        
                    }else{
                        Swal.fire({
                                title:"Upload IMEI Fail!", 
                                // html: "Our customer service will contact you soon.", 
                                icon:"warning",
                        });
                        
                    }
                    this.LoadingUploadSeen=false;
                }
            );
        }else{
            alert('Please upload template file.');
        }
    },

    uploadFile() {
        // console.log(this.$refs.file.files[0]);
        this.Images = this.$refs.file.files[0];
    },
    


    

  },
  components: {
        Layout,
        PageHeader,
        // DataTable,
    },

    computed: {
      rowsList() {
        return this.orderlist.length
      },
    },
};
require("@/assets/css/datatable.css");
</script>
<template>

  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-header align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">Insert IMEI for order {{ this.$route.params.OrderId }}</h4> 
                    <div class="pull-right"><a class="btn btn-success waves-effect" :href="newUrl">Download Template</a></div>
                </div>

                <div class="card-body">
                    <div class="live-preview">
                        <div class="row align-items-center g-12">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        
                                        <div class="overflow-auto">
                                            <div v-if='isLoadingToDisplayData'>
                                                <div class="spinner-border text-success" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                

                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <input class="form-control"  type="file" @change="uploadFile" ref="file">
                                                        <div class="d-grid gap-2">
                                                            <br>
                                                            
                                                            
                                                        </div>
                                                        <button class="btn btn-secondary dary waves-effect waves-light " type="button" @click="submitFile"> Upload IMEI </button>
                                                    </div>
                                                </div>
                                                <br><br>
                                                <table class="table align-middle table-nowrap mb-0">
                                                    <thead >
                                                        <tr>
                                                            <td scope="col"><b>No.</b></td>
                                                            <th scope="col">PID</th>
                                                            <th scope="col">Brand</th>
                                                            <th scope="col">Model</th>
                                                            <th scope="col">Imei</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in orderlist.device" :key="index" class="content">
                                                            <td>{{ index+1 }}</td>
                                                            <td>{{ item.pid }}</td>
                                                            <td>{{ item.brand }}</td>
                                                            <td>{{ item.model }}</td>
                                                            <td>{{ item.imei }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </Layout>
</template>